import React, { useState } from 'react';
import { images } from '../../constants/index';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import './Navbar.scss';
import { motion } from 'framer-motion';
const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <>
      <nav className="app__navbar">
        <div className="app__navbar-logo">
          <a href="/">
            <img src={images.logo} alt="logo"></img>
          </a>
        </div>
        <ul className="app__navbar-links">
          {['Home', 'About', 'Skills', 'Projects', 'Contact'].map((link) => {
            return (
              <li className="app__navbar-link" key={`link ${link}`}>
                <a href={`#${link}`}>{link}</a>
                <div className="navbar__dot"></div>
              </li>
            );
          })}
        </ul>
        <div className="app__navbar-menu">
          <HiMenuAlt4 onClick={() => setToggle(true)} />
          {toggle && (
            <div>
              <ul>
                {['Home', 'About', 'Skills', 'Projects', 'Contact'].map(
                  (item) => (
                    <li key={`links ${item}`}>
                      <a href={`#${item}`} onClick={() => setToggle(false)}>
                        {item}
                      </a>
                    </li>
                  )
                )}
              </ul>
              <HiX onClick={() => setToggle(false)} />
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
